module.exports = __webpack_public_path__ + "static/media/SIX.5e5badef.png";